import { useCallback } from "react"

export const useFindObjectPropertyTp = () => {

    return useCallback((data: Record<string, any>): string | undefined => {
        return Object.keys(data).find((key) => /tp$/i.test(key))
    }, [])
}
